<template>
    <div class="border-0">
        <!-- <video src="../../assets/Video.mp4" class="video-element" autoplay muted ></video> -->
        <img src="../../assets/Principal/qhatu_VIDEO.gif" alt="GIF animado">


    </div>
</template>

<script>
export default {
    name: 'PowerbySpinne',

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>

<style  scoped>

* {
    margin: 0;
    padding: 0;
    border: 0;
    /* Otros estilos de reinicio */
}
.video-element {
  width: auto;
  height: auto;
  height: auto;
  border: none; /* Esto elimina cualquier borde */
  outline: none; /* Esto elimina el contorno de enfoque al hacer clic */
}


</style>